import type { PersonaDefinition } from '../types/persona';
import { BusinessWorkspace } from './business-workspace';
import { IndividualWorkspace } from './individual-workspace';
import { PractitionerWorkspace } from './practitioner';

export const personaDefinitions = [
  {
    id: 'practitioner',
    label: 'Tax practitioner',
    shortLabel: 'Practice',
    hero: {
      eyebrow: 'Tax practitioner product',
      title: 'Client invoice evidence',
      accent: 'and exception review.',
      description: 'Add source records for an assigned client and review category and VAT suggestions before any draft invoice work.',
    },
    Workspace: PractitionerWorkspace,
  },
  {
    id: 'business',
    label: 'Business',
    shortLabel: 'Business',
    hero: {
      eyebrow: 'Business product',
      title: 'Invoice evidence',
      accent: 'ready for review.',
      description: 'Add your business source records and review the returned lines before preparing a draft invoice.',
    },
    Workspace: BusinessWorkspace,
  },
  {
    id: 'individual',
    label: 'Individual',
    shortLabel: 'Individual',
    hero: {
      eyebrow: 'Individual product',
      title: 'Personal income records',
      accent: 'and review questions.',
      description: 'Organise supported income records and identify questions to discuss with a qualified professional.',
    },
    Workspace: IndividualWorkspace,
  },
] satisfies PersonaDefinition[];
